import { Box } from "@mui/material";
import { ReactNode } from "react";
import "../../styles/scss/ActionIcons.scss";

interface ActionIcon {
  icon: ReactNode;
  isDelete?: boolean;
  tooltip: string;
  onClick: (e: React.MouseEvent) => void;
  variant?: 'default' | 'view' | 'edit' | 'delete';
}

interface ActionIconsProps {
  actions: ActionIcon[];
}

export default function ActionIcons({ actions }: ActionIconsProps) {
  return (
    <Box className="action-icons">
      {actions.map((action, index) => (
        <Box key={index} className="tooltip">
          <button
            className={`action-btn ${action.variant || (action.isDelete ? 'delete' : 'edit')}`}
            onClick={(e) => {
              e.stopPropagation();
              action.onClick(e);
            }}
          >
            {action.icon}
          </button>
          <span className="tooltip-text">{action.tooltip}</span>
        </Box>
      ))}
    </Box>
  );
}
